import React from 'react';

export default function DynamicButton(props) {
    const { data } = props;

    return (
        <a href={data.buttonLink} className="inline-block">
            <button type="button" className="dynamic-button text-xl">
                <span className="dynamic-button__content">{data.buttonCopy}</span>
                <span className="dynamic-button__background" />
            </button>
        </a>
    );
}
